import {ReactElement, ReactNode} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import usePublicUser from 'public/hooks/usePublicUser';
import Footer from './components/Footer';
import Header from './components/Header';

type Props = {
  children: ReactNode;
};

const useStyles = makeStyles(theme => ({
  content: {
    backgroundColor: theme.palette.common.white
  }
}));

function PublicLayout({children}: Props): ReactElement {
  const classes = useStyles();
  const publicUser = usePublicUser();
  return (
    <div>
      <Header publicUser={publicUser} />
      <div className={classes.content}>{children}</div>
      <Footer />
    </div>
  );
}

export default PublicLayout;
